import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
  IsNumber,
  IsArray,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
interface UserMaterialGetFolderItemsResponse {
  folders: string[];
  items: Items[];
};

interface Items {
  id: number;
  folder_id: number;
  item_url: string;
  item_type: string;
  user_id: number;
  is_enabled: number;
  tags?: string;
  vector_library_id: string;
  vector_library_file_url: string;
  width: number;
  height: number;
  duration: number;
  fps: number;
  size: number;
  vector_ids?: string;
  use_mark_value: string;
  use_sub_mark_values: string;
  parant_folder_id: number;
  task_id: string;
  task_status: string;
  n8n_task_id?: string;
  create_time: number;
  update_time: number;
  deleted_time: number;
};

export class MaterialFolderItemData {
  @Required("Id cannot be empty")
  @IsNumber("Id must be a number")
  id: number;

  @Required("Folder id cannot be empty")
  @IsNumber("Folder id must be a number")
  folderId: number;

  @Required("Item url cannot be empty")
  @IsString("Item url must be a string")
  itemUrl: string;

  @Required("Vector library file url cannot be empty")
  @IsString("Vector library file url must be a string")
  vectorLibraryFileUrl: string;

  @Required("Item type cannot be empty")
  @IsString("Item type must be a string")
  itemType: string;

  @Required("User id cannot be empty")
  @IsNumber("User id must be a number")
  duration: number;

  @Required("Create time cannot be empty")
  @IsNumber("Create time must be a number")
  createTime: number;
}

export class UserMaterialGetFolderItemsData {
  @IsArray("Items must be an array")
  items: MaterialFolderItemData[];
}

const transformAndValidateAgent = (
  response: UserMaterialGetFolderItemsResponse
): UserMaterialGetFolderItemsData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, UserMaterialGetFolderItemsData);
  } catch (error) {
    console.error("User material get folder items data validation failed:", error.message);
    throw error;
  }
};

/** 获取指定文件夹下的素材和文件 */
export const userMaterialGetFolderItems = async (folderId: number): Promise<UserMaterialGetFolderItemsData> => {
  const response = await api.post<UserMaterialGetFolderItemsResponse>('/user_material/get_folder_items', {
    folder_id: folderId,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
